import { IconButton } from '@mui/material';
import { Add } from '@tempo-io/sui-icons';
import type React from 'react';
import { useSwimlaneRootProps } from '@/components/ui/swimlane/context';
import { AXIS_HEIGHT, COLUMN_HEADER_HEIGHT, GRID_GAP, ROW_HEADER_WIDTH } from '../constants';

export interface IAddHeader {
  level: 1 | 2;
  orientation: 'column' | 'row';
}

export function AddHeader({ level, orientation }: IAddHeader) {
  const { columnAxisLabelText, rowAxisLabelText, actions, rowHeaders } = useSwimlaneRootProps();

  const hasAxisLabelRow = typeof rowAxisLabelText === 'string';
  const hasAxisLabelColumn = typeof columnAxisLabelText === 'string';
  const hasNoRowHeaders = rowHeaders.length === 0;
  const orientationStyle = {
    column: {
      gridArea: 'addCol',
      top: hasAxisLabelColumn ? `${COLUMN_HEADER_HEIGHT.value + GRID_GAP.value}px` : 0,
      marginRight: 16,
    },
    row: {
      gridArea: 'addRow',
      left: hasAxisLabelRow ? `${ROW_HEADER_WIDTH.vertical.value + GRID_GAP.value}px` : 0,
      marginBottom: 16,
    },
  };

  const noRowHeaders: React.CSSProperties = {
    position: 'sticky',
    top: hasAxisLabelColumn
      ? `${AXIS_HEIGHT.value + COLUMN_HEADER_HEIGHT.value + GRID_GAP.value}px`
      : `${COLUMN_HEADER_HEIGHT.value + GRID_GAP.value}px`,
  };

  return (
    <div
      style={{
        ...orientationStyle[orientation],
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'start',
        position: 'sticky',
        boxSizing: 'content-box',
        zIndex: 20,
      }}
    >
      <IconButton
        onClick={(e) => actions?.headerActions?.addHiddenHeaderValue(level, e)}
        size="small"
        aria-label={`Add ${orientation} header`}
        style={{
          width: ROW_HEADER_WIDTH.vertical.label,
          height: COLUMN_HEADER_HEIGHT.label,
          ...(hasNoRowHeaders ? noRowHeaders : {}),
        }}
      >
        <Add />
      </IconButton>
    </div>
  );
}
